import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) {
      localStorage.setItem("access_token", data.access_token);
    }
    // /auth/login hanya balas subset field (id/email/name/role/employee_id) — TIDAK termasuk
    // client_id/group_id dkk. Kalau langsung dipakai sebagai user tanpa refresh halaman, akun
    // Group Client jadi tidak melihat menu "Project Group"-nya sampai reload manual. /auth/me
    // (via get_current_user) selalu mengembalikan dokumen user LENGKAP dari DB — pakai itu
    // sebagai sumber kebenaran, bukan payload /auth/login yang sengaja ringkas.
    try {
      const { data: full } = await api.get("/auth/me");
      setUser(full);
      return full;
    } catch {
      setUser(data);
      return data;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("access_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
